export abstract class PerguntaRequestBase {
    public pergunta: string = '';
    public codigo: number = 0;
    public qtdMinEscolhas: number = 0;
    public qtdMaxEscolhas: number = 0;
    public respostas: RespostaRequestBase[];
}

export abstract class RespostaRequestBase {
    public resposta: string = '';
    public codigoPergunta: number = 0;
    public codigo: number = 0;
}

export class PerguntaProdutoRequest extends PerguntaRequestBase {
    public codigoProduto: number = 0;
    public override respostas: RespostaProdutoRequest[] = [];
}

export class PerguntaRespose {
    public pergunta: string = '';
    public qtdMinEscolhas: number = 0;
    public qtdMaxEscolhas: number = 0;
    public codigo: number = 0;
    public respostas: RespostaResponse[] = [];
}

export class PerguntaViewModel {
    public pergunta: string = '';
    public respostas: RespostaViewModel[] = [];
    public qtdMinEscolhas: number = 0;
    public qtdMaxEscolhas: number = 0;
    public codigo: number = 0;

    public emEdicao: boolean = false;
    public emDeletacao: boolean = false;

    public validar(): boolean {
        return (
            this.qtdMinEscolhas <= this.qtdMaxEscolhas &&
            this.pergunta.length > 0
        );
    }
}

export class RespostaResponse {
    public resposta: string = '';
    public codigo: number = 0;
    public codigoProduto: number = 0;
    public codigoPergunta: number = 0;
}

export class RespostaProdutoRequest extends RespostaRequestBase {
    public codigoProduto: number = 0;
}

export class RespostaViewModel {
    public resposta: string = '';
    public codigo: number = 0;
    public codigoPergunta: number = 0;
    public check: boolean = false;

    public emEdicao: boolean = false;
    public emDeletacao: boolean = false;

    public validar(): boolean {
        return (
            this.resposta.length > 0
        )
    }
}

export class PerguntaFamiliaRequest extends PerguntaRequestBase {
    public codigoFamilia: number = 0;
    public override respostas: RespostaFamiliaRequest[] = [];
}

export class RespostaFamiliaRequest extends RespostaRequestBase {
    public codigoFamilia: number = 0;
}